import { gql } from 'apollo-angular';

// #735: Notification-Einstellungen im Nutzerprofil.
// Alle Operationen sind selbst-scoped (der Server bezieht sie auf den aufrufenden Nutzer),
// es wird bewusst keine userId uebergeben.

export enum NotificationChannelKey {
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
  PUSH = 'PUSH'
}

export enum ChannelPolicy {
  FORCED = 'FORCED',
  DEFAULT_ON = 'DEFAULT_ON',
  DEFAULT_OFF = 'DEFAULT_OFF',
  HIDDEN = 'HIDDEN'
}

export interface NotificationChannelInfo {
  channel: NotificationChannelKey;
  policy: ChannelPolicy;
  effectiveEnabled: boolean;
  editable: boolean;
}

export interface NotificationTypeInfo {
  typeKey: string;
  label: string;
  categoryKey: string;
  categoryLabel: string;
  sortOrder: number;
  channels: NotificationChannelInfo[];
}

export interface CatalogQueryResponse {
  catalog: NotificationTypeInfo[];
}

export interface UpdatePreferenceResponse {
  updateNotificationPreference: NotificationTypeInfo;
}

export interface SendTestNotificationResponse {
  sendTestNotification: boolean;
}

export interface SeedDemoNotificationsResponse {
  seedDemoNotifications: number;
}

/**
 * label und categoryLabel kommen fertig uebersetzt vom Server (Argument locale).
 * Sie werden im Frontend NIE durch die translate-Pipe geschickt.
 */
export const NOTIFICATION_CATALOG_QUERY = gql`
  query getNotificationCatalog($locale: String) {
    catalog: getNotificationCatalog(locale: $locale) {
      typeKey
      label
      categoryKey
      categoryLabel
      sortOrder
      channels {
        channel
        policy
        effectiveEnabled
        editable
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCE_MUTATION = gql`
  mutation updateNotificationPreference($input: UpdateNotificationPreferenceInput!) {
    updateNotificationPreference(input: $input) {
      typeKey
      label
      categoryKey
      categoryLabel
      sortOrder
      channels {
        channel
        policy
        effectiveEnabled
        editable
      }
    }
  }
`;

export const SEND_TEST_NOTIFICATION_MUTATION = gql`
  mutation sendTestNotification($typeKey: String!) {
    sendTestNotification(typeKey: $typeKey)
  }
`;

/**
 * Client-Dok §6.6: `userId` bleibt unbenutzt — genau wie bei den anderen Operationen hier
 * bezieht sich der Aufruf ohne das Argument auf den aufrufenden Nutzer selbst.
 */
export const SEED_DEMO_NOTIFICATIONS_MUTATION = gql`
  mutation seedDemoNotifications {
    seedDemoNotifications
  }
`;
